import {
    getPrecision,
    createSegment,
    genSegments,
    formChunksData,
    getAudioGenerationExtra
} from '../helpers/utils';

export default {
    fetching() {
        const duration = this.bookpart.audio_duration;
        const { speed_chunks, trim_chunks } = getAudioGenerationExtra(this.bookpart);

        this.duration = Math.ceil(duration * 1000);
        this.precision = getPrecision(this.duration);
        this.waveContainerWidth = Math.ceil(this.duration / this.precision);
        this.basePrecision = this.precision;
        if (this.hasChanges)
            this.segments = genSegments({ speed_chunks, trim_chunks }, this.precision);
        this.transition({ type: 'FETCHED' });
        this.loading = false;
    },
    async creating({ event }) {
        const vm = this;
        const { target, pageX } = event;
        const { left: offset } = target.getBoundingClientRect();
        const width = 0;
        const left = pageX - offset;

        this.uncompletedSegment = {
            ...createSegment({ width }),
            get time() {
                const time = ((this.left + this.width) * vm.precision) / 1000;
                return time.toFixed(0);
            },
            left,
            width
        };
    },
    ready() {
        this.selectedSegment = null;
    },
    completed({ type, event, params }) {
        let { left: offset } = event.target.getBoundingClientRect();
        let { width = 0, left = event.pageX - offset } = this.uncompletedSegment || {};
        const duration = Math.round(width * this.precision);
        const start = (this.rtl ? left - width : left) * this.precision;
        const end = Math.round(start + duration);
        const segment = {
            ...this.uncompletedSegment,
            duration,
            start,
            end
        };

        if (type === 'DURATION_ADJUSTMENT') {
            return this.updateSegment(params.id, params);
        }

        this.uncompletedSegment = undefined;
        this.addSegment(segment);
    },
    reading({ params }) {
        const { id } = params;
        this.selectedSegment = id;
        this.updateSegment(id, { isNew: false });
        this.segmentSpeed = this.activeSegment.speed;
    },
    editing({ type, params }) {
        if (type === 'SEGMENT_UNDO') {
            return this.updateActiveSegment(params);
        }
    },
    cutted() {
        this.updateActiveSegment({
            type: 'trim',
            cut: true
        });
    },
    deleted() {
        if (!this.selectedSegment) return;

        this.updateActiveSegment({
            isDeleted: true
        });
        this.selectedSegment = null;
    },
    saving() {
        this.loading = true;
        const data = formChunksData(this.segments, this.hasChanges);
        this.selectedSegment = null;

        this.$emit('save', data);
    }
};
